import { render, staticRenderFns } from "./GroupForecasterManager.vue?vue&type=template&id=31c5e51a&scoped=true&"
import script from "./GroupForecasterManager.vue?vue&type=script&lang=js&"
export * from "./GroupForecasterManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5e51a",
  null
  
)

export default component.exports